// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-spreadsheet.js';

import { paths } from '../generated/file-spreadsheet';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-spreadsheet', Original, paths);
